module.exports = __webpack_public_path__ + "img/halfhouricon.f32ebd23.svg";